"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createActionCreators = void 0;
// base functions
exports.createActionCreators = (names) => {
    return names.reduce((mapped, type) => {
        mapped[type] = ((payload) => (payload ? { type, payload } : { type }));
        return mapped;
    }, {});
};
//# sourceMappingURL=actions.js.map